// StoryContext.tsx
import React, { createContext, useState, useCallback } from 'react';

export const StoryContext = createContext<{
  deletedStories: Set<string>;
  markAsDeleted: (storyId: string) => void;
  isDeleted: (storyId: string) => boolean;
}>({
  deletedStories: new Set(),
  markAsDeleted: () => {},
  isDeleted: () => false
});

export const StoryProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [deletedStories, setDeletedStories] = useState<Set<string>>(new Set());

  const markAsDeleted = useCallback((storyId: string) => {
    setDeletedStories(prev => {
      const newSet = new Set(prev);
      newSet.add(storyId);
      return newSet;
    });
  }, []);

  const isDeleted = useCallback((storyId: string) => {
    return deletedStories.has(storyId);
  }, [deletedStories]);

  return (
    <StoryContext.Provider value={{ deletedStories, markAsDeleted, isDeleted }}>
      {children}
    </StoryContext.Provider>
  );
};